<div class="main-header-wrapper">
    <div class="main-header-left">
        <kw-logo-nav [logoNavConfig]="logoNavConfig"></kw-logo-nav>
    </div>
    <div class="main-header-center">
        <ng-container *ngIf="containsMainNav;else search">
            <kw-main-nav [mainMenuConfig]="mainMenuConfig"></kw-main-nav>
            <!-- <nb-menu [items]="menuItems" class="menu-items horizontal-menu" #mainHeaderMenu></nb-menu> -->
        </ng-container>
        <ng-template #search>
            <kw-search-nav></kw-search-nav>
        </ng-template>
    </div>
    <div class="main-header-right">
        <kw-tool-nav></kw-tool-nav>
    </div>
</div>
